import DOMMutationObserver from './DOMMutationObserver';
import { coreLocalization } from './translations';

document.addEventListener('DOMContentLoaded', function (event) {
  const baseUrl = window.location.origin;
  const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  const vehicleResultsContainer = document.getElementById('vehicle-results-container');
  const accountNumber = getAccountNumber();

  if (accountNumber === false) {
    // No point doing anything if the account number is missing.
    return false;
  }

  // Watches the vehicle container for refreshes and reloads carfax badges
  const observer = new DOMMutationObserver(loadBadges);
  const observerOptions = { childList: true, subtree: true };
  observer.observe(vehicleResultsContainer, observerOptions);

  loadBadges();

  /**
   * Fetches Carfax badges
   *
   * @param {string} vins Vehicle Identification Numbers
   */
  async function fetchBadgeData(vins) {
    try {
      const url = new URL(`${baseUrl}/carfaxbadge/`);
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          vinNumbers: vins,
          accountNumber: accountNumber,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken,
        },
      });

      let data = await response.json();

      if (response.ok && response.status === 200) {
        return data;
      }

      console.error(data.errors);
      return false;
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * Updates <img> element attributes with Carfax badge data
   * The following code documentation is an attempt to document Carfax badging API.
   * Sadly they do not have anything.
   *
   * @param {HTMLElement} element
   *
   * @param {Object}      badgeData Carfax badge object.
   *
   * @param {array|null}  badgeData.BadgeList List of badges when more than one (Accident-Free, One-Owner, etc)
   * @param {string}      badgeData.BadgeList.BadgeImageUrl
   * @param {string}      badgeData.BadgeList.BadgeName
   * @param {int}         badgeData.BadgeList.BadgeType
   *
   * @param {string|null} badgeData.BadgesImageUrl Image url for all badges.
   * @param {bool}        badgeData.HasBadge
   * @param {int}         badgeData.ResultCode
   * @param {string}      badgeData.ResultMessage
   * @param {string}      badgeData.VIN
   * @param {string|null} badgeData.VhrReportUrl
   *
   * @return void
   */
  function updateBadgeElementImage(element, badgeData) {
    const imgTagElement = element.querySelector('img');

    if (hasBadgeImageUrl(badgeData) && isImageElementPresent(imgTagElement)) {
      imgTagElement.classList.add('carfax-img');
      imgTagElement.src = badgeData.BadgesImageUrl;

      imgTagElement.addEventListener('click', function (event) {
        window.open(badgeData.VhrReportUrl);
      });

      element.appendChild(imgTagElement);
    }
  }

  /**
   * Checks if carfax badge data has an image url
   *
   * @param badgeData
   * @returns {boolean}
   */
  function hasBadgeImageUrl(badgeData) {
    if (badgeData.BadgesImageUrl === null) {
      console.warn(
        `${coreLocalization.gettext('No Carfax Badge Image URL found for VIN')}: ${badgeData.VIN}`,
      );
      return false;
    }

    return true;
  }

  /**
   * Checks if Carfax badge HTML has an <img> tag.
   * Not sure why yet this isn't generated on the fly instead of relying on users to specify "proper" HTML.
   *
   * @param imgTagElement <div><img></div>
   * @returns {boolean}
   */
  function isImageElementPresent(imgTagElement) {
    if (imgTagElement && imgTagElement.nodeName === 'IMG') {
      return true;
    }

    console.warn(coreLocalization.gettext('Carfax badge is missing an <img /> element.'));
    return false;
  }

  /**
   * Find first carfax badge element with attribute data-account-number
   *
   * @returns {string|boolean} Account number if success else false
   */
  function getAccountNumber() {
    const firstCarfaxBadge = document.querySelector('.carfax-badge');

    if (firstCarfaxBadge === null) {
      // No carfax badge element found means no carfax badging is not enabled
      return false;
    }

    // Basic check that element has data-account-number attribute
    if (firstCarfaxBadge.dataset.accountNumber === undefined) {
      console.warn(
        coreLocalization.gettext('Carfax account number missing. Unable to load badges.'),
      );
      return false;
    }

    return firstCarfaxBadge.dataset.accountNumber;
  }

  /**
   * Searches the page for elements with class .carfax-badge and creates
   * a list of VINs to request badges from server
   */
  function loadBadges() {
    const carfaxBadges = document.querySelectorAll('.carfax-badge');

    if (carfaxBadges.length > 0) {
      let vins = [];

      [...carfaxBadges].forEach((carfaxBadge) => {
        vins.push(carfaxBadge.dataset.vin);
      });

      fetchBadgeData(vins).then((data) => {
        // Stop observer so there's no infinite loop
        observer.disconnect();

        data.forEach((carfaxInfo, index) => {
          if (!carfaxInfo.BadgesList) {
            return;
          }

          updateBadgeElementImage(carfaxBadges[index], carfaxInfo.BadgesList[0]);
        });

        // Reconnect observer once all badges are loaded
        observer.observe(vehicleResultsContainer, observerOptions);
      });
    }
  }
});
